enum ReportLinkCardEnum {
  DIAGNOSTIC = "diagnostic",
  FORMATIVES = "formatives",
  SCREENER = "screener",
  BENCHMARK_PERFORMANCE = "benchmark-performance",
  CUMULATIVE_STANDARDS = "cumulative-standards",
  CUMULATIVE_PERFORMANCE = "cumulative-performance",
  USAGE = "usage",
  GROWTH_USAGE = "growth-usage"
}

export default ReportLinkCardEnum;
